export const USER_DATA = "useData";
export const USER_ID = "userId";
export const IS_LOGGED = "islogged";
export const USER_SYSTEM_ROLE = "systemRole";
export const LOGIN_USER_DISTRICT_ID = "LoginUserDistrictId";
export const THEME_COLOR = "dark-theme";
export const TOURNAMENT_ID="tournamentid"
export const CURRENT_SERVER_URL="current_server_url"
export const CLIENT_TITLE="client_title"